import React from 'react';
import { MessageSquare, Trash2, X, ShieldAlert, Target } from 'lucide-react';

const UserProfileModal = ({ user, onClose, onChat, onUnfriend, onBlock }) => {
    if (!user) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="w-full max-w-sm bg-gray-900 rounded-2xl border border-gray-700 shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">

                {/* Header / Cover */}
                <div className="h-32 bg-gradient-to-br from-blue-600 to-purple-700 relative">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 p-2 bg-black/20 hover:bg-black/40 rounded-full text-white transition backdrop-blur-md"
                    >
                        <X size={20} />
                    </button>

                    {/* Avatar - overlapping */}
                    <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
                        <div className="w-24 h-24 rounded-full border-4 border-gray-900 bg-gray-800 flex items-center justify-center text-4xl font-bold text-white shadow-xl">
                            {user.displayName?.charAt(0) || '?'}
                        </div>
                        {/* Online Status */}
                        <div className="absolute bottom-1 right-1 w-5 h-5 bg-green-500 rounded-full border-4 border-gray-900"></div>
                    </div>
                </div>

                {/* Body */}
                <div className="pt-14 pb-6 px-6 flex-1 overflow-y-auto">
                    <div className="text-center mb-6">
                        <h2 className="text-2xl font-bold text-white">{user.displayName}</h2>
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-gray-800 rounded-full text-xs font-medium text-gray-400 mt-2 border border-gray-700">
                            <Target size={12} />
                            {user.profile?.role || 'Cricketer'}
                        </span>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 gap-3 mb-6">
                        <div className="bg-gray-800/50 p-4 rounded-xl border border-gray-800 text-center">
                            <span className="block text-3xl font-black text-neon-cyan font-mono tracking-tighter">
                                {user.grind_score || 0}
                            </span>
                            <span className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Grind Score</span>
                        </div>
                        <div className="bg-gray-800/50 p-4 rounded-xl border border-gray-800 text-center">
                            <span className="block text-3xl font-black text-white font-mono tracking-tighter">
                                {user.matches_played || 0}
                            </span>
                            <span className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">Matches</span>
                        </div>
                    </div>

                    {/* Bio / About */}
                    <div className="mb-6">
                        <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">About</h3>
                        <p className="text-sm text-gray-400 leading-relaxed">
                            {user.profile?.bio || "No bio available. Just here to play some cricket!"}
                        </p>
                    </div>
                </div>

                {/* Footer Actions */}
                <div className="p-4 bg-gray-800 border-t border-gray-700 grid grid-cols-2 gap-3">
                    <button
                        onClick={() => onChat(user)}
                        className="col-span-2 py-3 bg-neon-cyan text-black font-bold rounded-xl hover:bg-cyan-400 transition flex items-center justify-center gap-2"
                    >
                        <MessageSquare size={18} />
                        Message
                    </button>

                    <button
                        onClick={() => onUnfriend(user)}
                        className="py-3 bg-red-500/10 text-red-500 font-bold rounded-xl hover:bg-red-500/20 transition flex items-center justify-center gap-2 border border-red-500/20"
                    >
                        <Trash2 size={18} />
                        Unfriend
                    </button>

                    <button
                        onClick={() => onBlock(user)}
                        className="py-3 bg-gray-700 text-gray-400 font-bold rounded-xl hover:bg-gray-600 hover:text-white transition flex items-center justify-center gap-2"
                    >
                        <ShieldAlert size={18} />
                        Block
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserProfileModal;
